const v=new Proxy((s) => s,{get:()=>v})
export default v
